(() => {
  const CONFIG_SELECTOR = '[data-elo20-gift-config]';
  const AUTO_GIFT_PROPERTY = '_elo_auto_gift';
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  let timer;
  let syncing = false;
  let queued = false;

  const cartJsonUrl = () => {
    const base = window.routes?.cart_url || '/cart';
    return `${base.replace(/\.js$/, '')}.js`;
  };

  const request = async (url, payload) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        ...payload,
        sections: SECTIONS,
        sections_url: window.location.pathname,
      }),
    });
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || 'Подаръкът не можа да бъде обновен.');
    return state;
  };

  const render = (state) => {
    if (!state?.sections) return;
    const drawer = document.querySelector('cart-drawer[data-elo-cart-v19]');
    if (!drawer?.renderContents) return;
    drawer.renderContents(state, {
      open: drawer.classList.contains('active'),
      source: 'elo-gift-v20',
    });
  };

  const sync = async () => {
    if (syncing) {
      queued = true;
      return;
    }

    const config = document.querySelector(CONFIG_SELECTOR);
    const variantId = Number(config?.dataset.variantId || 0);
    const threshold = Number(config?.dataset.threshold || 5000);
    if (config?.dataset.ready !== 'true' || !variantId || !threshold) return;

    syncing = true;
    try {
      const cartResponse = await fetch(cartJsonUrl(), {
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store',
      });
      if (!cartResponse.ok) throw new Error('Количката не можа да бъде проверена.');
      const cart = await cartResponse.json();
      const items = Array.isArray(cart.items) ? cart.items : [];
      const giftItems = items.filter((item) => Number(item.variant_id) === variantId);
      const qualifyingSubtotal = items.reduce((total, item) => {
        const isGift = Number(item.variant_id) === variantId || item.properties?.[AUTO_GIFT_PROPERTY] === 'true';
        return isGift ? total : total + Number(item.final_line_price || item.line_price || 0);
      }, 0);

      let state;
      if (qualifyingSubtotal >= threshold && giftItems.length === 0) {
        state = await request(window.routes?.cart_add_url || '/cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { [AUTO_GIFT_PROPERTY]: 'true' } }],
        });
      } else if (giftItems.length > 0) {
        const updates = {};
        if (qualifyingSubtotal >= threshold) {
          giftItems.forEach((item, index) => {
            const wantedQuantity = index === 0 ? 1 : 0;
            if (Number(item.quantity) !== wantedQuantity) updates[item.key] = wantedQuantity;
          });
        } else {
          giftItems.forEach((item) => { updates[item.key] = 0; });
        }

        if (Object.keys(updates).length > 0) {
          state = await request(window.routes?.cart_update_url || '/cart/update.js', { updates });
        }
      }

      if (state) render(state);
    } catch (error) {
      console.warn('[ÉLO gift]', error.message || error);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        schedule(80);
      }
    }
  };

  const schedule = (delay = 140) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(sync, delay);
  };

  window.EloGiftV20 = { schedule, sync };
  document.addEventListener('DOMContentLoaded', () => {
    schedule(40);
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => schedule());
    } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => schedule());
    }
  });
  document.addEventListener('elo:cart-rendered', (event) => {
    if (event.detail?.source !== 'elo-gift-v20') schedule(80);
  });
})();
